export default __webpack_public_path__ + "static/media/Page22.f6226a3d.txt";